import { Modal } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Shortlist from 'components/Images/Shortlist.png'
import { UploadMsgFlex } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/ConfirmReleaseOffer/style'
import { ShortlistDiv } from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/Style/style'
import React from 'react'
const ShortListDrawer = ({
  shortListDrawer,
  setShortListDrawer,
  selectedIds,
  onShortlistButtonClick,
}) => {
  const onClose = () => {
    setShortListDrawer(false)
  }

  return (
    <div>
      <Modal
        open={shortListDrawer}
        centered // This prop centers the modal vertically and horizontally
        footer={''}
        maskClosable={false} // Prevent closing the modal when clicking outside
        closable={false} // Hide the close button
        bodyStyle={{
          borderRadius: '20px',
          padding: '20px',
          textAlign: 'center',
          height: '434px',
        }}
        width={828}
      >
        <UploadMsgFlex column center centerVertically>
          <img src={Shortlist} alt="shortlistImage" />
          <ShortlistDiv>
            {' '}
            Are you sure to shortlist these {selectedIds?.length}{' '}
            {selectedIds?.length == 1 ? 'candidate?' : 'candidates?'}{' '}
          </ShortlistDiv>
          <Flex styles={{ gap: '15px' }}>
            <Button.Secondary
              text="No"
              width="64px"
              height="38px"
              onClick={onClose}
            />
            <Button.Primary
              text="Yes"
              width="64px"
              height="38px"
              onClick={() => {
                onShortlistButtonClick()
                setShortListDrawer()
              }}
            />
          </Flex>
        </UploadMsgFlex>
      </Modal>
    </div>
  )
}

export default ShortListDrawer
